import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { useSelector } from 'react-redux';
import {
  InputBox, InputGroup, KeyboardContainer, NextButton,
} from '../../../utils/style';
import Keyboard from '../../common/keyboard';
import { isPhoneComplete, onlyDigits } from './phone';

// Изолированная версия InnerData без ModalInput: корневое дерево остаётся
// стабильным при открытии клавиатуры (поля не размонтируются, неактивные
// просто скрываются через display), поэтому нет «промигивания».
function PhoneInnerData({ createTicket, bottomStyle }) {
  const { input, button } = useSelector((state) => state.config.config.style);
  const [activeField, setActiveField] = useState(null); // null | 1 | 2 | 3
  const [values, setValues] = useState(['', '', '']);

  const phoneOk = isPhoneComplete(values[0]);

  const setPhone = (raw) => setValues((v) => [onlyDigits(raw).slice(0, 10), v[1], v[2]]);
  const setEmail = (raw) => setValues((v) => [v[0], raw, v[2]]);
  const setFio = (raw) => setValues((v) => [v[0], v[1], raw]);

  const fieldSetters = { 1: setPhone, 2: setEmail, 3: setFio };
  const setActiveValue = fieldSetters[activeField];

  // Скрываем неактивные поля, не размонтируя их (как в модалке, но без flicker).
  const fieldStyle = (n) => (activeField && activeField !== n ? { display: 'none' } : undefined);

  const readyStyle = {
    ...button,
    width: 'min-content',
    height: 'min-content',
    margin: '30px auto 0',
    padding: '5px 35px',
  };

  return (
    <KeyboardContainer>
      <InputBox button={input}>
        <InputGroup button={button} input={input} style={fieldStyle(1)}>
          <span className="phoneLabel">Ваш телефон</span>
          <InputMask
            className={`phonenumber ${activeField === 1 ? 'activeInput' : ''}`}
            value={values[0]}
            mask="+7 (999) 999 99 99"
            alwaysShowMask
            readOnly
            onClick={() => setActiveField(1)}
          />
        </InputGroup>

        <InputGroup button={button} input={input} style={fieldStyle(2)}>
          <span className="phoneLabel">Ваш e-mail</span>
          <input
            readOnly
            className={activeField === 2 ? 'activeInput' : ''}
            value={values[1]}
            onClick={() => setActiveField(2)}
          />
        </InputGroup>

        <InputGroup button={button} input={input} style={fieldStyle(3)}>
          <span className="phoneLabel">ФИО</span>
          <input
            readOnly
            className={activeField === 3 ? 'activeInput' : ''}
            value={values[2]}
            onClick={() => setActiveField(3)}
          />
        </InputGroup>

        {activeField ? (
          <>
            <Keyboard
              styleButton={button}
              login={50}
              id={activeField === 1 ? 'number' : 'text'}
              width={button.width}
              value={values[activeField - 1]}
              setValue={setActiveValue}
            />
            <div className="ready" style={readyStyle} onClick={() => setActiveField(null)}>
              {' '}
              Готово
            </div>
          </>
        ) : (
          <div className="flex" style={{ marginTop: 50 }}>
            <NextButton
              style={{
                ...bottomStyle,
                opacity: phoneOk ? 1 : 0.5,
                pointerEvents: phoneOk ? 'auto' : 'none',
              }}
              onClick={() => {
                if (!phoneOk) return;
                createTicket({
                  clientPhoneNumber: values[0],
                  clientEmail: values[1],
                  clientFIO: values[2],
                });
              }}
            >
              {' '}
              Записаться
            </NextButton>
          </div>
        )}
      </InputBox>
    </KeyboardContainer>
  );
}

export default PhoneInnerData;
